const listFormat = new Intl.ListFormat(import.meta.env.VITE_LOCALE, {
  type: "conjunction",
});

export function conjunctionJoin(list: string[]) {
  return listFormat.format(list);
}
